import { BaseEntity } from '~/app/core/models/base-entity.model';

export class ProfileAddress extends BaseEntity<ProfileAddress> {
  streetname?: string;
  zipcode?: string;
  city?: string;
  country?: string;
}
